import React from 'react';

export function ErrorMessage({ error, onRetry }) {
  if (!error) return null;
  return (
    <div className="bg-red-50 border border-red-200 text-red-700 p-4">
      <div className="flex items-center justify-between">
        <p className="text-sm">{String(error)}</p>
        {onRetry ? (
          <button onClick={onRetry} className="ml-4 px-3 py-1 bg-tertiary text-primary text-sm">Retry</button>
        ) : null}
      </div>
    </div>
  );
}



